export default function (request, { templateurl }) {
  const prefix = process.env.VUE_APP_SEARCH_SERVER

  return {
    /**
     * 搜索关键词
     */
    queryKeywords ({ query }) {
      return request({
        url: `${prefix}/zt_keyword/_search`,
        method: 'get',
        params: query
      })
    },

    /**
     * 搜索客户
     */
    queryCustomers ({ query }) {
      return request({
        url: `${prefix}/customer_user/_search`,
        method: 'get',
        params: query
      })
    }

  }
}
